/**
 * Different types of ResponsiveLayout sizes.
 *
 * @readonly
 * @enum {string}
 * @public
 * @author veith
 */
enum ResponsiveLayoutSize {
  one = "one",
  two = "two",
  three = "three",
  four = "four",
  six = "six",
}

export {ResponsiveLayoutSize};
